var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgMoovit = function SvgMoovit(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 156,
    viewBox: "0 0 130 156",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_924)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.42 0C29.946 0 2 27.964 2 62.46C2 109.304 64.42 156.15 64.42 156.15C64.42 156.15 126.84 109.306 126.84 62.46C126.838 27.964 98.892 0 64.42 0Z",
    fill: "#F05523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.554 62.29C87.488 62.29 84.992 59.796 84.992 56.728C84.992 53.66 87.488 51.166 90.554 51.166C93.62 51.166 96.116 53.66 96.116 56.728C96.116 59.794 93.62 62.29 90.554 62.29Z",
    fill: "#262728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.77 62.29C35.704 62.29 33.208 59.796 33.208 56.728C33.208 53.66 35.702 51.166 38.77 51.166C41.836 51.166 44.332 53.66 44.332 56.728C44.332 59.794 41.838 62.29 38.77 62.29Z",
    fill: "#262728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.256 80.2441C53.754 80.2441 45.478 73.4541 45.132 73.1661C43.922 72.1581 43.758 70.3561 44.768 69.1461C45.776 67.9361 47.572 67.7721 48.784 68.7781C48.902 68.8741 55.912 74.5361 65.258 74.5361C74.656 74.5361 80.406 69.4781 80.462 69.4261C81.634 68.3721 83.438 68.4721 84.492 69.6481C85.544 70.8201 85.446 72.6241 84.27 73.6781C83.97 73.9441 76.812 80.2441 65.256 80.2441Z",
    fill: "#262728"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_924"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 130,
    height: 156,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMoovit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/moovit.dec344d7.svg";
export { ForwardRef as ReactComponent };